import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoomObjects = _resolveComponent("RoomObjects")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogAddAction = _resolveComponent("DialogAddAction")
  const _component_DialogAddTriggerAndCondition = _resolveComponent("DialogAddTriggerAndCondition")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ElScrollbar, { class: "h-100" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roomsWithObjects, (r, index) => {
          return (_openBlock(), _createBlock(_component_RoomObjects, {
            key: `room-${index}`,
            room: r,
            onAddObject: _cache[1] || (_cache[1] = (object) => _ctx.openShowDialog(object))
          }, null, 8, ["room"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_DialogAddAction, {
      "is-visible": _ctx.isVisibleDialogAction,
      "onUpdate:is-visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isVisibleDialogAction = $event)),
      onConfirm: _ctx.handleDoAddObjectAction,
      actionToAdd: _ctx.tempToAdd
    }, null, 8, ["is-visible", "onConfirm", "actionToAdd"]),
    _createVNode(_component_DialogAddTriggerAndCondition, {
      "is-visible": _ctx.isVisibleDialogTriggerOrCondition,
      "onUpdate:is-visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isVisibleDialogTriggerOrCondition = $event)),
      onConfirm: _ctx.handleDoAddTriggerOrCondition,
      triggerOrActionToAdd: _ctx.tempToAdd,
      "step-to-add": _ctx.stepToAdd,
      triggerOrConditionType: _ctx.triggerOrConditionType,
      triggerOrConditionName: _ctx.triggerOrConditionName
    }, null, 8, ["is-visible", "onConfirm", "triggerOrActionToAdd", "step-to-add", "triggerOrConditionType", "triggerOrConditionName"])
  ], 64))
}